<app-page-bar></app-page-bar>

<app-page>
  <div class="list-container">
    <header class="page-header">
      <h1>Message Templates</h1>
    </header>

    <mat-tab-group animationDuration="0ms">
      <!-- Email Templates Tab -->
      <mat-tab label="Email Templates">
        <mat-nav-list class="template-list">
          <a mat-list-item *ngFor="let template of emailTemplates" [routerLink]="['/settings/templates/email', template.id]">
            <mat-icon matListIcon>email</mat-icon>
            <h3 matLine>{{template.name}}</h3>
            <p matLine *ngIf="template.description">{{template.description}}</p>
            <mat-icon matSuffix>chevron_right</mat-icon>
          </a>
          <div class="empty-state" *ngIf="emailTemplates.length === 0">
            <p>No email templates found.</p>
          </div>
        </mat-nav-list>

        <div class="fab-bottom-right">
          <a mat-fab routerLink="/settings/templates/email/new" color="primary"
             aria-label="Add an email template">
            <mat-icon>add</mat-icon>
          </a>
        </div>
      </mat-tab>

      <!-- Text Message Templates Tab -->
      <mat-tab label="Text Message Templates">
        <mat-nav-list class="template-list">
          <a mat-list-item *ngFor="let template of smsTemplates" [routerLink]="['/settings/templates/sms', template.id]">
            <mat-icon matListIcon>textsms</mat-icon>
            <h3 matLine>{{template.name}}</h3>
            <p matLine *ngIf="template.description">{{template.description}}</p>
            <mat-icon matSuffix>chevron_right</mat-icon>
          </a>
          <div class="empty-state" *ngIf="smsTemplates.length === 0">
            <p>No text message templates found.</p>
          </div>
        </mat-nav-list>

        <div class="fab-bottom-right">
          <a mat-fab routerLink="/settings/templates/sms/new" color="primary"
             aria-label="Add a text message template">
            <mat-icon>add</mat-icon>
          </a>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</app-page>
